var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9.5C6.0375 9.5 5.8595 9.428 5.716 9.284C5.572 9.1405 5.5 8.9625 5.5 8.75C5.5 8.5375 5.572 8.3595 5.716 8.216C5.8595 8.072 6.0375 8 6.25 8H7.75C7.9625 8 8.14075 8.072 8.28475 8.216C8.42825 8.3595 8.5 8.5375 8.5 8.75C8.5 8.9625 8.42825 9.1405 8.28475 9.284C8.14075 9.428 7.9625 9.5 7.75 9.5H6.25ZM1 2C0.7875 2 0.6095 1.92825 0.466 1.78475C0.322 1.64075 0.25 1.4625 0.25 1.25C0.25 1.0375 0.322 0.85925 0.466 0.71525C0.6095 0.57175 0.7875 0.5 1 0.5H13C13.2125 0.5 13.3905 0.57175 13.534 0.71525C13.678 0.85925 13.75 1.0375 13.75 1.25C13.75 1.4625 13.678 1.64075 13.534 1.78475C13.3905 1.92825 13.2125 2 13 2H1ZM3.25 5.75C3.0375 5.75 2.85925 5.678 2.71525 5.534C2.57175 5.3905 2.5 5.2125 2.5 5C2.5 4.7875 2.57175 4.60925 2.71525 4.46525C2.85925 4.32175 3.0375 4.25 3.25 4.25H10.75C10.9625 4.25 11.1405 4.32175 11.284 4.46525C11.428 4.60925 11.5 4.7875 11.5 5C11.5 5.2125 11.428 5.3905 11.284 5.534C11.1405 5.678 10.9625 5.75 10.75 5.75H3.25Z",
    fill: "#6F0D0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSvg);
export default __webpack_public_path__ + "static/media/FilterSvg.f6c6381fb14fd830362667e43d0da748.svg";
export { ForwardRef as ReactComponent };